import { createSlice } from '@reduxjs/toolkit';
import { apiCallBegan } from 'client/store/middleware/api/api';
import { NotificationEventStatusType } from 'common/enums/notification-service-enums';
import { FileParsingStatus } from 'common/interfaces/objects-interfaces';

const initialState = {
  error: null as string | null,
  isUploading: false,
  sourceId: null,
  progress: 0,
  parsingStatus: null as FileParsingStatus | null,
};

const upload = createSlice({
  name: 'upload',
  initialState,
  reducers: {
    uploadStarted: (state) => {
      state.error = null;
      state.isUploading = true;
      state.sourceId = null;
      state.parsingStatus = FileParsingStatus.PROGRESS;
    },
    uploadSucceeded: (state, action) => {
      state.isUploading = false;
      state.sourceId = action.payload.sourceid;
      state.progress = 0;
    },
    uploadFailed: (state, action) => {
      state.isUploading = false;
      state.error = action.payload;
      state.sourceId = null;
      state.parsingStatus = FileParsingStatus.FAILED;
    },
    progressUpdated: (state, action) => {
      state.parsingStatus = action.payload.status;
      if (action.payload.status === NotificationEventStatusType.Running) {
        state.progress = action.payload.progress;
      }
      if (action.payload.status === NotificationEventStatusType.Finished) {
        state.progress = 100;
        state.parsingStatus = FileParsingStatus.SUCCESS;
      }
      if (action.payload.status === FileParsingStatus.FAILED) {
        state.error = NotificationEventStatusType.Error;
      }
    },
    resetUploadStatus: () => initialState,
  },
});

export const {
  uploadStarted,
  uploadSucceeded,
  uploadFailed,
  progressUpdated,
  resetUploadStatus,
} = upload.actions;

export default upload.reducer;

interface IUploadFormProps {
  data: FormData,
  objectType: string,
  nodeid: string,
  archiveid: string,
  onUploadProgress?: (progressEvent: ProgressEvent) => void,
}

export const uploadFormData = ({
  data,
  objectType,
  nodeid,
  archiveid,
  onUploadProgress,
}: IUploadFormProps) => {
  const params = new URLSearchParams({
    objectType,
    nodeid,
    archiveid,
  });

  return apiCallBegan({
    url: `/archive/upload?${params.toString()}`,
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data,
    onStart: uploadStarted.type,
    onUploadProgress,
    // @ts-ignore
    onSuccess: (response) => ({
      type: uploadSucceeded.type,
      payload: response,
    }),
    onError: uploadFailed.type,
  });
};
